import { SourcingRequisitionResponse } from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";

export class RequisitionService extends CommonAxiosService{

    URL ="/requisition";

    async getAll(): Promise<SourcingRequisitionResponse> {
        return ({status:true,errorCode:1,internalMessage:'Data retrived',
    data:[ {
        sourcingRequisitionId : 1,
        styleId: 11,
        style:'WV34D103',
        styleDescription:'ROLL CUFFSHORT',
        requestNo:'REQ001',
        expectedDate:"15-09-2023",
        indentDate:"12-09-2023",
        fabricInfo: [
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF001'
            },
            {
                content:'Natural Fabrics',
                fabricType:'Silk',
                weave:1,
                weight:200,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'embossed treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab002',
                color:1,
                pch:1,
                moq:'250',
                moqUnit:'Pieces',
                season:'Spring',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Green',
                weaveName:'Plain Weave',
                pchName: 'Sujith',
                supplierName:'Srinu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF002'
      
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF003'
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF005'
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF006'
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab001',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Blue',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF007'
            },
        ],
        trimInfo:[
            {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST001'
            },
            {
                trimType: "Zipper",
                trimCode: "ZIP002",
                description: "Nylon Zipper",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '50',
                m3TrimCode:'TR001',
                remarks: "Water-resistant",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST002'
              },
              {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST003'

            },
            {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST004'
            
            },
            {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST005'
            },
            {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST006'
            },
            {
                trimType: "Button",
                trimCode: "BTN001",
                description: "Metallic Gold Button",
                size: 1, // Size in centimeters
                color: 1,
                quantity: '100',
                m3TrimCode:'TR003',
                remarks: "Shiny finish",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'pieces',
                shahiTrimCode:'ST007'
            },
        ],
        versionFlag:1
    },
    {
        sourcingRequisitionId : 2,
        styleId: 12,
        style:'WV34D104',
        styleDescription:'Bagee phant',
        requestNo:'REQ002',
        expectedDate:"17-09-2023",
        indentDate:"13-09-2023",
        fabricInfo: [
            {
                content:'Natural Fabrics',
                fabricType:'Wool',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'bulletproofing',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab003',
                color:1,
                pch:1,
                moq:'200',
                moqUnit:'Pieces',
                season:'Winter',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Yellow',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

      
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            }
        ],
        trimInfo:[
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST001'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiTrimCode:'ST002'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiTrimCode:'ST002'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiTrimCode:'ST002'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiTrimCode:'ST002'

              },
        ],
        versionFlag:1
    },
    {
        sourcingRequisitionId : 2,
        styleId: 12,
        style:'WV34D105',
        styleDescription:'Ton jeans',
        requestNo:'REQ003',
        expectedDate:"17-09-2023",
        indentDate:"13-09-2023",
        fabricInfo: [
            {
                content:'Natural Fabrics',
                fabricType:'Wool',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'bulletproofing',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab003',
                color:1,
                pch:1,
                moq:'200',
                moqUnit:'Pieces',
                season:'Winter',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Yellow',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF003'

      
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'

    
            }
        ],
        trimInfo:[
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'Reels',
                shahiTrimCode:'St001'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'm',
                shahiTrimCode:'ST002'

              },
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'GRN',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST001'

              },
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST001'

              },
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST001'

              },
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST001'

              },
        ],
        versionFlag:1
    },
    {
        sourcingRequisitionId : 2,
        styleId: 12,
        style:'WV34D106',
        styleDescription:'smooth fabric',
        requestNo:'REQ004',
        expectedDate:"17-09-2023",
        indentDate:"14-09-2023",
        fabricInfo: [
            {
                content:'Natural Fabrics',
                fabricType:'Wool',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'bulletproofing',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab003',
                color:1,
                pch:1,
                moq:'200',
                moqUnit:'Pieces',
                season:'Winter',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Yellow',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF003'
      
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'
    
            }
        ],
        trimInfo:[
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST003'

              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiTrimCode:'ST004'
              },
        ],
        versionFlag:1
    },
    {
        sourcingRequisitionId : 2,
        styleId: 12,
        style:'WV34D107',
        styleDescription:'ladies wear',
        requestNo:'REQ005',
        expectedDate:"18-09-2023",
        indentDate:"14-09-2023",
        fabricInfo: [
            {
                content:'Natural Fabrics',
                fabricType:'Wool',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'bulletproofing',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab003',
                color:1,
                pch:1,
                moq:'200',
                moqUnit:'Pieces',
                season:'Winter',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'Yellow',
                weaveName:'Basket Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'm',
                shahiFabricCode:'SF003'
      
            },
            {
                content:'Natural Fabrics',
                fabricType:'Cotton',
                weave:1,
                weight:100,
                weightUnit: 'kg',
                width:12,
                construction:'12x14',
                yarnCount:100,
                yarnUnit: 'Tex',
                finish:'shrink resistance treatment',
                shrinkage:'2-3 %',
                m3FabricCode: 'Fab004',
                color:1,
                pch:1,
                moq:'100',
                moqUnit:'Pieces',
                season:'Summer',
                moqPrice:100,
                moqPriceUnit:'INR',
                supplier:1,
                grnDate:'09-08-2023',
                buyer:1,
                xlNo:'24',
                quantity: 100,
                colorName:'White',
                weaveName:'Checked Weave',
                pchName: 'Sagar',
                supplierName:'Naidu',
                buyerName:'Rajesh',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiFabricCode:'SF004'
    
            }
        ],
        trimInfo:[
              {
                trimType: "Thread",
                trimCode: "THR003",
                description: "Cotton Sewing Thread",
                size: 1, // Size in meters
                color: 1,
                quantity: '200',
                m3TrimCode:'TR001',
                remarks: "Strong and durable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'PO',
                quantityUnit: 'Reels',
                shahiTrimCode:'ST003'
              },
              {
                trimType: "Fabric",
                trimCode: "FAB004",
                description: "Cotton Blend Fabric",
                size: 2, // Size in meters
                color: 2,
                quantity: '30',
                m3TrimCode:'TR002',
                remarks: "Soft and breathable",
                sizeName:'L',
                colorName:'White',
                availableQuantity: 100,
                status: 'Stock',
                quantityUnit: 'm',
                shahiTrimCode:'ST004'

              },
        ],
        versionFlag:1
    }
    ]})
    }
}